import React, { Component } from 'react';
import Chart from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import { commaingNumber } from '../../../utils';

class Bargraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myChart: null,
    };
  }
  
  drawGraph = () => {
    var ctx = document.getElementById(this.props.id).getContext('2d');

    /**setting width of bar graph*/
    ctx.canvas.parentNode.style.width = this.props.width;

    const getBarTag = (type, value) => {
      if (!type) return '';
      else if (type === 'value') return value;
      else if (type === 'amount') return formatValue(value) ;
      else if (type === 'percentage') return value + '%';
      else if(type === 'in-thousands') return value + 'K';
    };

    const getDependentValue = (type, value) => {
      if (!type) return commaingNumber(value);
      else if (type === 'percentage') return value + '%';
      else if (type === 'amount') return formatValue(value);
      else if (type === 'rupees') return '₹' + commaingNumber(value);
      else if (type === 'in-thousands') return value + 'K';
    };

    const formatValue = (value) =>{
      if (value >= 10000000) {
        return (value / 10000000).toFixed(2) + ' Cr'; // Crores
      } else if (value >= 100000) {
        return (value / 100000).toFixed(2) + ' L'; // Lakhs
      } else if (value >= 1000) {
        return (value / 1000).toFixed(2) + 'K'; // Thousands
      }
      return value;
    }
  
    if (this.state.myChart) {
      this.state.myChart.destroy();
    }

    this.state.myChart = new Chart(ctx, {
      type: this.props.type,
      data: {
        labels: this.props.labels,
        datasets: this.props.stacked
          ? this.props.data.map((item, index) => {
              return {
                data: item,
                backgroundColor: this.props.backgroundColor[index],
              };
            })
          : [
              {
                data: this.props.data,
                backgroundColor: this.props.backgroundColor,
              },
            ],
      },

      options: {
        maintainAspectRatio: false /**to set custom height and width of bar graph set maintainAspectRatio to false*/,
        barTag: this.props.barTag,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          xAxes: [
            {
              maxBarThickness: 60,
              barThickness: 40,
              scaleLabel: {
                display: true,
                labelString: this.props.xAxesLabel,
                fontStyle: 'bold',
                fontSize: 14,
                fontColor: '#4d6189',
                fontFamily: 'ProximaNova',
              },
              gridLines: {
                display: false,
              },
              ticks:
                this.props.type === 'horizontalBar'
                  ? {
                      ...this.props.ticks,
                      fontFamily: 'ProximaNova',
                      // fontStyle: 'bold',
                      fontColor: '#8895AF',
                      callback: (value) => {
                        return getDependentValue(this.props.dataPoints, value);
                      },
                    }
                  : {
                      autoSkip: false,
                      fontFamily: 'ProximaNova',
                      // fontStyle: 'bold',
                      fontColor: '#8895AF',
                      callback: function (label, index, labels) {
                        if (/\s/.test(label)) {
                          const result = label.split(' ').filter((item) => !['', '-', '&amp;'].includes(item));
                          return result.length > 3 ? [...result.slice(0, 3), '...'] : result;
                          // return result;
                        } else {
                          return label;
                        }
                      },
                    },
              stacked: !!this.props.stacked,
            },
          ],
          yAxes: [
            {
              maxBarThickness: 60,
              barThickness: 40,
              scaleLabel: {
                display: true,
                labelString: this.props.yAxesLabel,
                fontStyle: 'bold',
                fontSize: 14,
                fontColor: '#4d6189',
              },
              gridLines: {
                drawBorder: false,
                display: !(this.props.type === 'horizontalBar'),
              },
              ticks:
                this.props.type === 'bar'
                  ? {
                      beginAtZero: true,
                      ...this.props.ticks,
                      fontFamily: 'ProximaNova',
                      // fontStyle: 'bold',
                      fontColor: '#8895AF',
                      padding: 8,
                      callback: (value) => {
                        return getDependentValue(this.props.dataPoints, value);
                      },
                    }
                  : { fontFamily: 'ProximaNova', fontColor: '#8895AF' },
              stacked: !!this.props.stacked,
            },
          ],
        },
        hover: {
          animationDuration: 0,
        },

        animation: {
          duration: 1,
          onComplete: function () {
            var chartInstance = this.chart;
            ctx = chartInstance.ctx;
            ctx.textAlign = 'center';
            ctx.font = Chart.helpers.fontString(12, 'bold', Chart.defaults.global.defaultFontFamily);
            ctx.fillStyle = '#4D6189';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach((dataset, i) => {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach((bar, index) => {
                var data = getBarTag(this.config.options.barTag, dataset.data[index]);
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
            });
          },
        },
      },
    });
  };

  componentDidMount() {
    if (!this.props.loading) this.drawGraph();
  }

  componentDidUpdate() {
    if (!this.props.loading) this.drawGraph();
  }

  chartWidth = () => Math.max(((this.props.labels?.length || 0) * 90), 1100);

  render() {
    if (this.props.loading) {
      return <Skeleton width="100%" height={this.props.loaderHeight} />;
    }

    if (this.props.type === "horizontalBar") {
      return (
        <div className="p-4 h-full pt-0">
          <canvas
            id={this.props.id}
            style={{ height: this.props.height }}
          ></canvas>
          <hr
            className="relative -top-12 left-28"
            style={{ width: "81%", borderTop: "1px solid #E5E8F0" }}
          />
        </div>
      );
    }

    return (
      <div className="p-4 h-full overflow-x-scroll pt-6">
        <div
          className="chart-container"
          style={{ width: `${this.chartWidth()}px` }}
        >
          <div>
            <canvas
              id={this.props.id}
              style={{ height: this.props.height }}
            ></canvas>
          </div>
        </div>
      </div>
    );
  }
}  

export default Bargraph;
